/* ==========================================================
   EVERLAST AUSTRALIA — HEADER INTERACTIONS
   - Hover a category nav item -> opens its mega menu panel
     (mirrors the reference prototype's onMouseEnter / onMouseLeave state)
   - Mouse leaves the whole nav bar -> closes any open panel
   - Hamburger -> opens/closes the mobile slide-in drawer
   - Search category dropdown -> folds the selected value into the
     `q` field using Shopify's real search syntax before submit,
     since Shopify's /search endpoint ignores an unrecognized
     "category" param on its own
   - Recently Viewed -> tracks product handles in localStorage as
     product pages load, renders them into any [data-ev-recently-viewed]
     panel, hides itself (or shows empty text) when there's nothing yet
   ========================================================== */
(function () {
  var catNavWrap = document.querySelector('[data-ev-catnav-wrap]');
  if (!catNavWrap) return;

  var buttons = catNavWrap.querySelectorAll('.ev-cat-btn[data-mega]');
  var panels = catNavWrap.querySelectorAll('.ev-mega-panel');

  function closeAllMega() {
    panels.forEach(function (p) { p.classList.remove('is-open'); });
    buttons.forEach(function (b) { b.classList.remove('is-active'); });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('mouseenter', function () {
      var key = btn.getAttribute('data-mega');
      var panel = document.getElementById('mega-' + key);
      if (!panel) return;
      closeAllMega();
      panel.classList.add('is-open');
      btn.classList.add('is-active');
    });
    // keyboard/focus support
    btn.addEventListener('focus', function () {
      btn.dispatchEvent(new Event('mouseenter'));
    });
  });

  catNavWrap.addEventListener('mouseleave', closeAllMega);

  // close mega menu on outside click (helps touch/hybrid devices)
  document.addEventListener('click', function (e) {
    if (!catNavWrap.contains(e.target)) closeAllMega();
  });

  /* ---------------- mobile drawer ---------------- */
  var openBtn = document.querySelector('[data-ev-open-menu]');
  var closeBtn = document.querySelector('[data-ev-close-menu]');
  var overlay = document.querySelector('[data-ev-mobile-overlay]');
  var drawer = document.querySelector('[data-ev-mobile-drawer]');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ---------------- mobile menu collapsible sub-menus ---------------- */
  if (drawer) {
    drawer.querySelectorAll('[data-ev-mobile-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-ev-mobile-group]');
        var sub = group ? group.querySelector('[data-ev-mobile-sub]') : null;
        if (!sub) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        // close any other open groups (accordion behaviour)
        drawer.querySelectorAll('[data-ev-mobile-toggle][aria-expanded="true"]').forEach(function (other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            var og = other.closest('[data-ev-mobile-group]');
            var os = og ? og.querySelector('[data-ev-mobile-sub]') : null;
            if (os) os.hidden = true;
          }
        });
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        sub.hidden = isOpen;
      });
    });
  }

  /* ---------------- search category → query syntax ----------------
     Shopify's /search endpoint has no built-in "category" param, so
     selecting a value in the dropdown used to do nothing — the form
     always submitted the same q + type=product regardless of what
     was selected. Instead of relying on an unrecognized param, we
     fold the selection into the q field itself using Shopify's real
     search operators (product_type:"..."/tag:"...") before the form
     submits. "collection" has no inline operator, so that case
     redirects into the collection's own page instead.
  ------------------------------------------------------------------- */
  document.querySelectorAll('[data-ev-search-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var select = form.querySelector('[data-search-category]');
      var input = form.querySelector('input[name="q"]');
      if (!select || !input || !select.value) return;

      var source = select.getAttribute('data-category-source');
      var value = select.value;
      var base = input.value.trim();

      if (source === 'product_type') {
        input.value = (base + ' product_type:"' + value + '"').trim();
      } else if (source === 'tag') {
        input.value = (base + ' tag:"' + value + '"').trim();
      } else if (source === 'collection') {
        e.preventDefault();
        window.location.href = '/collections/' + value + '?q=' + encodeURIComponent(base);
        return;
      }
      // select has no "name" attribute, so nothing extra is submitted
      // alongside the now-combined q value
    });

    // Auto-search as soon as a category is chosen (no need to click the button).
    // "All categories" (empty value) is the default and does not trigger a search.
    var catSelect = form.querySelector('[data-search-category]');
    if (catSelect) {
      catSelect.addEventListener('change', function () {
        if (!catSelect.value) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  });

  /* ---------------- recently viewed ---------------- */
  var RV_KEY = 'ev_recently_viewed';
  var header = document.querySelector('.ev-header[data-ev-current-product]');
  var currentHandle = header ? header.getAttribute('data-ev-current-product') : '';

  function rvGet() {
    try {
      var raw = window.localStorage.getItem(RV_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function rvSet(list) {
    try {
      window.localStorage.setItem(RV_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode, quota, etc) — fail silently */
    }
  }

  // Record the product currently being viewed (product pages only).
  if (currentHandle) {
    var list = rvGet().filter(function (h) { return h !== currentHandle; });
    list.unshift(currentHandle);
    if (list.length > 12) list = list.slice(0, 12);
    rvSet(list);
  }

  function rvCardMarkup(product) {
    var img = product.featured_image
      ? '<img src="' + product.featured_image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_200x200$1$2') + '" alt="' + (product.featured_image.alt || product.title) + '" width="200" height="200" loading="lazy" style="width:100%;height:100%;object-fit:contain;border-radius:10px;">'
      : '<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="6" width="18" height="12" rx="2"></rect><path d="M7 18v2M17 18v2"></path></svg>';

    var compareAt = product.compare_at_price;
    var price = product.price;
    var onSale = compareAt && compareAt > price;
    var priceMarkup = onSale
      ? '<span class="ev-mega-card-was">' + formatMoney(compareAt) + '</span><span class="ev-mega-card-now ev-mega-card-now--sale">' + formatMoney(price) + '</span>'
      : '<span class="ev-mega-card-now">' + formatMoney(price) + '</span>';
    var badge = onSale ? '<span class="ev-mega-card-badge">SALE</span>' : '';

    return (
      '<a href="/products/' + product.handle + '" class="ev-mega-card">' +
        '<div class="ev-mega-card-img">' + badge + img + '</div>' +
        '<div class="ev-mega-card-title">' + product.title + '</div>' +
        '<div class="ev-mega-card-price">' + priceMarkup + '</div>' +
      '</a>'
    );
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderRecentlyViewed(panel) {
    var grid = panel.querySelector('[data-ev-rv-grid]');
    var emptyEl = panel.querySelector('[data-ev-rv-empty]');
    var max = parseInt(panel.getAttribute('data-ev-rv-max'), 10) || 6;

    var handles = rvGet()
      .filter(function (h) { return h !== currentHandle; })
      .slice(0, max);

    if (!handles.length) {
      if (grid) grid.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    var fetches = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) {
        if (grid) grid.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (grid) grid.innerHTML = valid.map(rvCardMarkup).join('');
    });
  }

  var rvPanels = document.querySelectorAll('[data-ev-recently-viewed]');
  rvPanels.forEach(renderRecentlyViewed);
})();
